import { WMLConstructorDecorator } from "@windmillcode/wml-components-base";
import { JobStatusZeroProps } from "../job-status-zero/job-status-zero.component";

@WMLConstructorDecorator
export class JobsZeroCommonProps {
  constructor(props: Partial<JobsZeroCommonProps> = {}) { }
  jobInfo:any = new JobStatusZeroProps({})
}
